import axios from "axios";
import {BASE_URL} from '../global'

const apiPortal = axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const promiseLegislacao = apiPortal.post("/desif-web/servicodesif/consulta/legislacao")

export default {
    getLegislacao() {
        console.log("Chamando o serviço de Legislacao !!!")
        return promiseLegislacao;
    }
    
};
